import { render, staticRenderFns } from "./ManageAlerts.vue?vue&type=template&id=baf7ce7e&"
import script from "./ManageAlerts.vue?vue&type=script&lang=js&"
export * from "./ManageAlerts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/tempos21/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('baf7ce7e', component.options)
    } else {
      api.reload('baf7ce7e', component.options)
    }
    module.hot.accept("./ManageAlerts.vue?vue&type=template&id=baf7ce7e&", function () {
      api.rerender('baf7ce7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Layout/ManageAlerts.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/Layout/ManageAlerts.vue
// module id = d62M
// module chunks = 0